module.exports = __webpack_public_path__ + "static/media/oberflex-zebranogrisgalet-2560x1440.3b74bc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranogrisgalet-2560x1440.jpg
// module id = 1083
// module chunks = 37